import { useState, useEffect } from "react";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { MediaLogos } from "./MediaLogos";
import { WarningSigns } from "./WarningSigns";
import { Strategies } from "./Strategies";
import { FraudTypes } from "./FraudTypes";
import { Process } from "./Process";
import { Experts } from "./Experts";
import { Reviews } from "./Reviews";
import { WhyUs } from "./WhyUs";
import { CTASection } from "./CTASection";
import { Footer } from "./Footer";
import { BookingDialog } from "./BookingDialog";
import type { LeadData } from "./types";

export function LandingPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [lead, setLead] = useState<LeadData | null>(null);
  

  const openBooking = (data: LeadData) => {
    setLead(data);
    setBookingOpen(true);
  };

  // no-op; thank-you is handled via a dedicated route

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header onCta={() => document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" })} />
      <main>
        <>
          <Hero onSubmit={openBooking} />
          <MediaLogos />
          <WarningSigns />
          <Strategies />
          <FraudTypes />
          <Process />
          <Experts />
          <Reviews />
          <WhyUs />
          <CTASection
            onCta={() => document.getElementById("kontakt-cta")?.scrollIntoView({ behavior: "smooth" })}
            onSubmit={openBooking}
          />
        </>
      </main>
      <Footer />
      <BookingDialog
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        lead={lead}
        onComplete={() => setLead(null)}
      />
    </div>
  );
}